import * as React from "react";
import { Unstable_Popup as Popup } from "@mui/base/Unstable_Popup";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import { PopupBody } from "../Popup/components/PopupBody";
import { Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { resetState, setClickedThumbnail, setOpenClicked } from "../../store/ShelfView/conflictsPage";
import axios from "axios";
import { conflictDataActions, feedbackActions, shelfViewFeedbackActions } from "../../store/store";
import {  updateThumbnailDetailsAndKey } from "../../store/ShelfView/conflictThumbnail";
import moment from "moment";
import SaveThumbnailsTabs from "./SaveThumbnailsTabs";

const PopUp = ({anchor,setAnchor,clicked,setClicked}) => {
  
 // console.log(clicked,"clicked")
  const { packshots,open,clickedThumbnail,selectedSku } = useSelector((state) => state.conflictsPageStore);
  const {
    conflicts, curConflict, conflictedBrands,selectedConflictBrand,selectedThumbnailsToMarkCorrect
  } = useSelector(state => state.conflictDataStore);

  const {
    cursorDetails2
  } = useSelector(state => state.conflictThumbnailStore);
  const currentKey=cursorDetails2.currentKey;
  const thumbnails = cursorDetails2.thumbnailDetails;
  const {
    user,
    username,
    userId
  } = useSelector(state => state.userStore);

  const dispatch = useDispatch();


 
  const handleOpen=(event)=>{
    setClicked((prevValue)=>!prevValue)
    setAnchor(anchor ? null : event.currentTarget);
    dispatch(setOpenClicked(Boolean(anchor ? null : event.currentTarget)));
    dispatch(setClickedThumbnail(null));
   
  }
  const originalCursorDetails2=cursorDetails2;

  const handleSave = async(event)=>{
  
    if(selectedThumbnailsToMarkCorrect.length ===0 || selectedSku===null)
    {
      dispatch(feedbackActions.setSnackbarOpen(true))
      dispatch(
        feedbackActions.setSnackbarMessage(
          'No Selected skus or selected thumbnails are null !'
        )
      )
      dispatch(feedbackActions.setSnackbarMessageSeverity('warning'))
      setTimeout(() => {
        dispatch(feedbackActions.setSnackbarOpen(false));
      }, 5000);
    }
    else
    {
      const filteredThumbnail = thumbnails.filter((th) => {
        return !selectedThumbnailsToMarkCorrect.some((selected) => selected.thumbnailName === th.thumbnailName);
      });
      
      let filteredBrands=filteredThumbnail.map((th)=>th.predictions.sku_name);
      filteredBrands=[...new Set(filteredBrands)]
      
       const updatedSelectedThumbnails= selectedThumbnailsToMarkCorrect.map((d)=>({...d,
      activity: {
        ...d.activity,
        verified: 1,
        user: user,
        userID: userId,
        lastModifiedIST:moment.utc().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),
        lastModifiedUTC:moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        }}))

     dispatch(shelfViewFeedbackActions.setLoading(true));
      try{
        const response=await axios.post("/markThumbnail/mark_conflicted_thumbnail_correct",{selectedSku:selectedSku,selectedThumbnails:updatedSelectedThumbnails,cursorDetails2:originalCursorDetails2});
        //console.log(response)
      }
      catch(error){
        console.log(error,"error")
      }
      const cursorDetails2={
        thumbnailDetails:filteredThumbnail,
        currentKey:currentKey
      }
      //console.log(cursorDetails2)
      dispatch(resetState())
      dispatch(updateThumbnailDetailsAndKey(cursorDetails2));
      const brands={
        brands:filteredBrands
      }
      dispatch(conflictDataActions.setSelectedConflictedBrand(null))
      dispatch(conflictDataActions.setConflictedBrands(brands))
      dispatch(setOpenClicked(false));
      dispatch(setClickedThumbnail(null))
      setClicked((prevValue)=>!prevValue)
    setAnchor(anchor ? null : event.currentTarget);
    dispatch(setOpenClicked(Boolean(anchor ? null : event.currentTarget)));

      dispatch(conflictDataActions.resetSelectedThumbnailsToMarkCorrect())
      dispatch(shelfViewFeedbackActions.setLoading(false));
    }
   
  }
  const opens = Boolean(anchor);
  const id = open ? "simple-popup" : undefined;
  // console.log("open     =-----> ",open)
  return (
    <>
     {open && ( <Draggable
        defaultPosition={{ x: 450, y: 150 }}
        bounds={{ left: 0, top: 0 }}
      >
        <Popup id={id} open={open} anchor={anchor}>
          <PopupBody
            sx={{ width: "47rem", height: "32rem", padding: "1rem",position:"relative", '@media screen and (max-height: 680px)': {
              width: "44rem", height: "30rem",padding:"0.2rem"
            }, }}
          >
             <span style={{ display: "flex", justifyContent: "flex-end",marginBottom:"0.2rem" }}>
              <IconButton
                aria-label="close"
                style={{ padding: "0" }}
                 onClick={handleOpen}
                sx={{
                  "&:hover": {
                    backgroundColor: "#d7f3ff",
                  },
                 
                }}
              >
                <CloseIcon
                  sx={{
                    color: "rgba(73 , 148, 236, 0.875)",
                    fontWeight: "600",
                    fontSize:"16px",
                    border:"2px solid #d7f3ff",
                    padding:"1px",
                    borderRadius:"50%"
                   
                  }}
                />
              </IconButton>
            </span>
            <SaveThumbnailsTabs />
            <div style={{display:"flex",alignItems:"center",justifyContent:"center" ,marginTop: "1rem",gap:"1rem",position:"absolute",bottom:"1rem"}}>
            <Button variant="contained" onClick={ handleSave} sx={{ '@media screen and (max-height: 680px)': {
             padding:"0.3rem 0.2rem",fontSize:"0.8rem"
            }, }}>Save</Button>
            <Button variant="contained" onClick={handleOpen} sx={{ '@media screen and (max-height: 680px)': {
             padding:"0.3rem 0.2rem",fontSize:"0.8rem"
            }, }}>Close</Button>
            </div>

          </PopupBody>
        </Popup>
      </Draggable>)}
    </>
  );
};

export default PopUp;
